export default __webpack_public_path__ + "90a5947ba789262cfd502021491cdfd9.svg";